import React from 'react';
import { sk } from '../shared/skeletonClass';

export default function KpiCardSkeleton (): React.JSX.Element {
  return (
    <div className="rounded-xl border border-border bg-card p-4">
      <div className="flex items-center justify-between mb-2">
        <div className={`h-3 w-20 ${sk}`} />
        <div className={`h-5 w-5 rounded ${sk}`} />
      </div>
      <div className={`h-8 w-24 mb-2 ${sk}`} />
      <div className={`h-3 w-16 ${sk}`} />
    </div>
  );
}
